export default class TravelServiceOrderItemHotel {
  room_type = null;
  place_id = null;
  start_date = null;
  start_time = null;
  end_date = null;
  parking_required = false;
  is_insurance = false;
  is_breakfast = false;
  is_free_cancellation = false;
  currency = "PLN";
  is_additional_services = false;
  additional_services = null;
}
